import { render, staticRenderFns } from "./CallLogCard.vue?vue&type=template&id=dc0f357c&"
import script from "./CallLogCard.vue?vue&type=script&lang=js&"
export * from "./CallLogCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports